import React, { useState, useEffect, useRef } from 'react'
import { CreateButton, DynamicEntityIndex, FlashMessage, GlobalLoader, InputField, NumberInput, TextEditor, Modal, ModalAlert, SelectInput } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer } from '@reactiveonline/reactive_admin_shared-packages/utils'
import GlobalImports from '../shared/GlobalImports'

export default function Index({
  appProps, announcements, entityPath, icon, listColumns, groups, selectedColumns, readOnly
}) {
  const impactOptions = [
    { title: 'high', value: 1 },
    { title: 'medium', value: 2 },
    { title: 'low', value: 3 }
  ]
  const [announcement, setAnnouncement] = useState({
    group: groups[0],
    impact: impactOptions[2],
    position: 1,
    text: ''
  })
  const [announcementToDelete, setAnnouncementToDelete]   = useState(null)
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false)
  const [updating, setUpdating]                           = useState(false)
  const [loading, setLoading]                             = useState(false)
  const [renderKey, setRenderKey]                         = useState(1)
  const flashMessageRef = useRef(null)

  const closeAnnouncementModal = () => {
    setAnnouncement({
      group: groups[0],
      impact: impactOptions[2],
      position: 0,
      text: ''
    })
    setShowAnnouncementModal(false)
    setUpdating(false)
  }

  const actions = [
    { onClick: (event, item) => openEditModal(event, item), icon: 'fa-pen-to-square' },
    { onClick: (event, item) => openDeleteModal(event, item.id), icon: 'fa-trash' }
  ]

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => {
          if (column.label == 'text') {
            return (
              <div key={ column.label } className='item flex-1' style={ item.impact == 'high' && readOnly ? {color: 'red'} : {} }>
                <div dangerouslySetInnerHTML={{ __html: item.text }} />
              </div>
            )
          } else if (column.label == 'impact') {
            return (
              <div key={ column.label } className='item flex-1'>
                { Support.translations.announcement[item.impact] }
              </div>
            )
          } else {
            return dynamicTableItemRenderer(item, column)
          }
        })}
      </>
    )
  }

  function openEditModal(event, item) {
    event.preventDefault()
    retrieveAnnouncement(item)
  }

  function openDeleteModal(event, item) {
    event.preventDefault()
    setAnnouncementToDelete(item)
  }

  function retrieveAnnouncement(item) {
    setUpdating(true)
    setLoading(true)
    Rails.ajax({
      type: 'GET',
      url: `${entityPath}/${item.id}`,
      dataType: 'json',
      success: res => {
        setAnnouncement({
          id: res.announcement.id,
          group: { title: res.announcement.group, value: res.announcement.group},
          impact: impactOptions.filter( i => i.title == res.announcement.impact ? i.value : '' )[0] || impactOptions[2],
          text: res.announcement.text,
          position: res.announcement.position || 0
        })
        setLoading(false)
        setShowAnnouncementModal(true)
      }
    })
  }

  function deleteAnnouncement(item) {
    setLoading(true)
    Rails.ajax({
      type: 'DELETE',
      url: `${entityPath}/${item}`,
      dataType: 'json',
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setTimeout( ()=> {
          window.location.reload()
        }, 1000)
      }
    })
  }

  function handleSave() {
    if (announcement.group && announcement.group.value) {
      setLoading(true)
      const fd = new FormData()
      fd.append('announcement_text', announcement.text)
      fd.append('announcement_group', announcement.group.value)
      fd.append('announcement_position', announcement.position)
      fd.append('announcement_impact', announcement.impact?.title || '')

      Rails.ajax({
        type: 'POST',
        url: entityPath,
        dataType: 'json',
        data: fd,
        success: res => {
          flashMessageRef.current.show(res.message)
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        },
        error: res => {
          flashMessageRef.current.show(res.error, 'error')
          setLoading(false)
        }
      })
    } else {
      flashMessageRef.current.show(Support.translations.announcement.group_required, 'error')
    }
  }

  function handleUpdate() {
    if (announcement.group && announcement.group.value) {
      setLoading(true)
      const fd = new FormData()
      fd.append('announcement_text', announcement.text)
      fd.append('announcement_group', announcement.group.value)
      fd.append('announcement_position', announcement.position)
      fd.append('announcement_impact', announcement.impact?.title || '')

      Rails.ajax({
        type: 'PATCH',
        url: `${entityPath}/${announcement.id}`,
        dataType: 'json',
        data: fd,
        success: res => {
          flashMessageRef.current.show(res.message)
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        },
        error: res => {
          flashMessageRef.current.show(res.error, 'error')
          setLoading(false)
        }
      })
    } else {
      flashMessageRef.current.show(Support.translations.announcement.group_required, 'error')
    }
  }

  function handleDeletion(announcement) {
    setLoading(true)
    const fd = new FormData()
    fd.append('announcement_id', announcement)

    Rails.ajax({
      type: 'PATCH',
      url: entityPath,
      dataType: 'json',
      data: fd,
      success: res => {
        window.location.reload()
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      { !readOnly &&
        <div className='page-wrapper-header'>
          <div style={{ width: '100%' }}>
            <div className='flex-box items-center content-space-between flex-wrap' style={{ gap: 10 }}>
              <div className='page-header'>
                <i className={ `fa-light ${ icon }`} />
                <h1 className='page-header-title'>
                  { Support.translations.announcement.plural }
                </h1>
              </div>
              <CreateButton
                onClickCreate={ () => setShowAnnouncementModal(true) }
                createTitle={ Support.translations.announcement.create }
              />
            </div>
          </div>
        </div>
      }

      { readOnly &&
        <style dangerouslySetInnerHTML={{__html: `
          .table-wrapper .table-right, .table-wrapper .headers { display: none }
          .table-wrapper .table-middle { overflow: auto; width: 100% }
          .table-wrapper .rows .table-row .item { height: auto }
          .table-wrapper p { margin: 0px 0px 10px 0px  }
        ` }} />
      }

      <div className={`${readOnly ? 'flex-box flex-wrap' : 'row' }`} style={ readOnly ? { gap: 20 } : {} }>
        { announcements.map( (groupedAnnouncements, index)=>  {
          return (
            <div key={index} className={ `${readOnly ? 'flex-1' : ''}` }>
              { groupedAnnouncements.length > 0 &&
                <DynamicEntityIndex
                  initialTotalCount={ groupedAnnouncements.length || 0 }
                  initialItems={ groupedAnnouncements }
                  entity={ 'announcements' }
                  tabs={ [] }
                  tableHeadings={ selectedColumns }
                  itemRenderer={ itemRenderer }
                  itemsPath={ entityPath }
                  icon={ icon }
                  noResourcesTitle={ Support.translations.announcement.no_announcements }
                  listColumns={ listColumns }
                  columnTranslations={ Support.translations.columns }
                  headline={ groupedAnnouncements[0]?.group || '-' }
                  actions={ !readOnly ? actions : [] }
                  disableCustomization
                  disableDelete
                  disableSearch
                  disableUrlUpdates
                />
              }
            </div>
          )
        })}
      </div>

      { showAnnouncementModal &&
        <Modal
          visible
          mode='large'
          closeModal={ closeAnnouncementModal }
          action={ updating ? handleUpdate : handleSave }
          actionText={ updating ? Support.translations.announcement.update : Support.translations.announcement.create }
          cancelAction={ closeAnnouncementModal }
          disableAction={ false }
        >
          <h2>
            <i className={`m-r-10 fa-light ${icon}`} />{ Support.translations.announcement.create } { Support.translations.announcement.model_name }
          </h2>

          <div className='m-t-30 flex-box'>
            <div className='items-center content-space-between flex-1 flex-column p-r-10'>
              <div style={{ width: '100%' }}><b>{ Support.translations.announcement.group }</b></div>
              <div style={{ width: '100%' }}>
                <SelectInput
                  options={ groups }
                  currentOption={ announcement.group?.value || '' }
                  setCurrentOption={ option => setAnnouncement({...announcement, group: option}) }
                />
              </div>
            </div>

            <div className='items-center content-space-between flex-1 flex-column p-r-10'>
              <div style={{ width: '100%' }}><b>{ Support.translations.announcement.impact }</b></div>
              <div style={{ width: '100%' }}>
                <SelectInput
                  options={ impactOptions }
                  currentOption={ announcement.impact?.value || '' }
                  setCurrentOption={ option => setAnnouncement({...announcement, impact: option}) }
                />
              </div>
            </div>

            <div className='items-center content-space-between flex-1 flex-column p-r-10'>
              <div style={{ width: '100%' }}><b>{ Support.translations.announcement.position }</b></div>
              <div style={{ width: '100%' }}>
                <InputField>
                  <NumberInput
                    number={ announcement.position || 0 }
                    setNumber={ value => setAnnouncement({...announcement, position: value}) }
                    min={ 0 }
                  />
                </InputField>
              </div>
            </div>

          </div>

          <div className='m-t-10'>
            <TextEditor
              key={ renderKey }
              content={ announcement.text || '' }
              setContent={ (value)=> {
                setAnnouncement( prevState => ({...prevState, text: value}) )
              } }
            />
          </div>
        </Modal>
      }

      { announcementToDelete &&
        <ModalAlert
          alert={ ReactiveCore.translations.delete_alert }
          onSelect={ () => deleteAnnouncement(announcementToDelete) }
          onClose={ () => setAnnouncementToDelete(null) }
        />
      }

      { loading &&
        <div style={{ zIndex: 999999, position: 'absolute' }}>
          <GlobalLoader fullPage />
        </div>
      }

      <FlashMessage ref={ flashMessageRef } />
      <GlobalImports appProps={ appProps } />
    </>
  )
}
